<template>
    <div>
        <!-- Desktop search -->
        <div class="d-flex justify-content-start ms-4 d-none d-xl-flex">
            <input 
                type="text" 
                class="form-control form-control-sm cursor-pointer border border-theme"
                :class="inputClass"
                placeholder="Order Search..."
                @focus="$emitter.emit('focusOnSearch', {action: 'openGlobalSearchModal'})"
            />
        </div>
        <!-- Mobile and table search -->
        <div class="d-flex justify-content-start ms-4 d-xl-none">
            <button type="button" class="btn btn-sm btn-outline-theme p-1" @click="$emitter.emit('focusOnSearch', {action: 'openGlobalSearchModal'})">
                <Search/>
            </button>
        </div>
    </div>
</template>
<script>
import { Search} from "lucide-vue-next";

export default {
    name: 'SearchInput',
    components: {
        Search,
    },
    props: {
        inputClass: {
            type: String,
            default: ''
        }
    }
}
</script>